import React, { memo, useEffect } from 'react';
import { bool } from 'prop-types';
import { connect } from 'react-redux';

import Topbar from 'app/components/Topbar';
import { actionCreators as UtilityActions } from 'redux/utility/actions';

import styles from './styles.module.scss';
import Login from './components/Login';
import ComplaintForm from './components/ComplaintForm';

const EntitiesComplaints = ({ session, dispatch }) => {
  useEffect(() => {
    if (session) {
      dispatch(UtilityActions.getComplaintForm());
    }
  }, [session, dispatch]);

  return (
    <div className={styles.screenContainer}>
      <Topbar isPublic />
      <div className={styles.container}>{!session ? <Login /> : <ComplaintForm session={session} />}</div>
    </div>
  );
};

EntitiesComplaints.propTypes = {
  session: bool
};

const mapStateToProps = store => ({
  session: store.customProcedures.entitySession
});

export default connect(mapStateToProps)(memo(EntitiesComplaints));
